import { render } from "./DashboardActivity.vue?vue&type=template&id=e2c8d354&scoped=true&ts=true&lang=pug"
import script from "./DashboardActivity.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashboardActivity.vue?vue&type=script&lang=ts&setup=true"

import "./DashboardActivity.vue?vue&type=style&index=0&id=e2c8d354&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2c8d354"]])

export default __exports__